import { useState } from "react";
import OutsideCloser from "@/utils/outside-closer";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { useTranslation } from "react-i18next";
import { FaWindowClose } from "react-icons/fa";

type PropsType = {
  label?: string;
  name?: string;
  register?: any;
  required?: boolean;
  watch?: any;
  errors?: any;
  options: Option[] | string[] | any[];
  width?: any;
  onChange?: any;
  value?: any;
  textSize?: string;
  reset?: any;
  scroll?: boolean;
  withoutLabel?: boolean;
  disabled?: boolean;
  setValue?: any;
  resetValue?: boolean;
};
type Option = {
  label: string;
  value: string | number;
  replaceAll?: any;
};
const Select: React.FC<PropsType> = ({
  name,
  register,
  required = false,
  setValue,
  watch,
  options,
  label,
  errors,
  width,
  onChange,
  value,
  textSize = "",
  withoutLabel = false,
  scroll = false,
  disabled = false,
  resetValue = false,
}) => {
  const { i18n } = useTranslation();
  const validationStyle = () => {
    if (errors?.[name]) {
      return "ring-red-600 ring-2";
    } else {
      return "";
    }
  };
  const responsiveArrows = () => {
    if (i18n.language === "en") {
      return "right-2";
    } else {
      return "left-2";
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  return (
    <OutsideCloser
      className={`w-full flex flex-col ${width ? width : "w-full 	"} `}
      onClose={() => setIsOpen(false)}
    >
      <div className="relative flex flex-col my-2 ">
        <div
          className={`flex flex-col h-[35px] justify-center relative select-none bg-[#F7F7F7] ${validationStyle()} ${
            disabled ? "opacity-30 cursor-not-allowed" : ""
          }  ${isOpen ? `  shadow ` : ` `} group rounded-md`}
          onClick={() => (disabled ? null : setIsOpen(!isOpen))}
        >
          {withoutLabel === false && (
            <label
              className={`absolute capitalize px-3 text-sm font-normal transition-all duration-300 text-old-silver ${
                watch(name) ? "-translate-y-2.5" : ""
              } ${textSize}`}
            >
              {label ? label : name}
            </label>
          )}

          <div
            className={`w-full  h-full text-base font-bold text-[#585757] ${
              watch(name) ? "" : "hidden"
            }`}
          >
            <p className={`px-3 pt-3 ${textSize} `}>
              {options?.[0]?.value
                ? options?.find?.(
                    (option) => String(option.value) === String(watch(name))
                  )?.label
                : options
                    ?.find?.((option) => String(option) === String(watch(name)))
                    ?.replaceAll?.("_", " ") || value}
            </p>
          </div>
          <div className={`absolute  ${responsiveArrows()} top-2`}>
            {isOpen ? (
              <>
                <TiArrowSortedUp
                  size="1.2rem"
                  onClick={() => setIsOpen(!isOpen)}
                  className={`text-black ${
                    disabled ? "cursor-not-allowed" : "cursor-pointer"
                  } `}
                />
              </>
            ) : (
              <TiArrowSortedDown
                size="1.2rem"
                onClick={() => setIsOpen(!isOpen)}
                className={`text-black ${
                  disabled ? "cursor-not-allowed" : "cursor-pointer"
                } `}
              />
            )}
          </div>
        </div>
        {!disabled && (
          <div
            className={`absolute top-8 w-full z-50 ${
              isOpen
                ? ` h-auto max-h-[12rem] ${
                    scroll && options?.length > 4
                      ? "overflow-y-scroll show-scroll-bar form-wrap"
                      : "overflow-y-auto"
                  }  shadow-md rounded-b-xl`
                : `hidden`
            } `}
          >
            {options?.map((item, index: number) => (
              <div
                key={Math.random() + index}
                role="select"
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
                className={`w-full relative h-full px-3 pt-2 text-base font-medium outline-none  text-[#585757]  ${
                  watch(name) && watch(name) === item.value
                    ? ` bg-[#F7F7F7]  `
                    : `hover:bg-weathered-storm  bg-[#F7F7F7]  `
                } `}
              >
                <p className={`capitalize ${textSize}`}>
                  {item?.label || item?.replaceAll?.("_", " ")}
                </p>

                <input
                  aria-label={label}
                  label={label ? label : name}
                  type="radio"
                  name={name}
                  value={item?.value || item}
                  required={required}
                  className="absolute top-0 bottom-0 left-0 right-0 w-full h-full opacity-0 cursor-pointer"
                  {...register(name, { onChange })}
                />
              </div>
            ))}
          </div>
        )}
        {resetValue && watch(name) && (
          <div
            onClick={() => setValue(name, "")}
            className={`absolute flex items-center justify-center rounded-full cursor-pointer text-md top-[0.65rem] ${
              i18n.language === "en" ? "right-7" : "left-7"
            } `}
          >
            <FaWindowClose />
          </div>
        )}
      </div>
      {/*  {errors && (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <small className="px-3 -mt-2 text-red-600">{message}</small>
          )}
        />
      )} */}
    </OutsideCloser>
  );
};
export default Select;
